import CONFIG from 'config';

function isApp() {
    const url = new URL(window.location.href);
    const params = Object.fromEntries(url.searchParams.entries());

    const keys = Object.keys(params);

    return keys.some((k) => k === CONFIG.linkUrlParamListener.params[0] || k === CONFIG.linkUrlParamListener.params[1]);
}

export default {
    corriere: {
        components: [
            {
                type: 'ext',
                src: 'https://components2.corriereobjects.it/rcs_iabtfc2/v5/index.min.js',
                priority: 1,
                enable: !isApp(),
            },
            {
                type: 'module',
                src: 'Corriere/CMP',
                priority: 1,
                enable: !isApp(),
            },
            {
                type: 'module',
                src: 'Corriere/Datalayer',
                priority: 1,
            },
            {
                type: 'module',
                src: 'Corriere/Permutive',
                priority: 1,
            },
            {
                type: 'module',
                src: 'Corriere/GPT',
                priority: 1,
            },
            {
                type: 'ext',
                src: 'https://www.googletagmanager.com/gtag/js?id=DC-9927244',
                priority: 1,
            },
            {
                type: 'module',
                src: 'Corriere/Gtag',
                priority: 1,
            },
            {
                type: 'module',
                src: 'Corriere/Adobe',
                priority: 1,
            },
            {
                type: 'module',
                src: 'Corriere/Nielsen',
                priority: 1,
            },
            {
                type: 'module',
                src: 'Corriere/Revive',
                priority: 1,
            },
        ],
    },
    gazzetta: {
        components: [
            {
                type: 'ext',
                src: 'https://dev-components.gazzettaobjects.it/rcs_gaz_comments/v1/index.js',
                enableOffline: true,
                legacy: true,
                onElementsPresence: {
                    targets: ['.elementsPresence', '#anotherdiv'],
                    event: 'DOMContentLoaded',
                },
                priority: 1,
            },
            {
                id: 'normal_mobile_2015',
                type: 'style',
                src: 'https://css2.corriereobjects.it/includes2013/LIBS/css-notcompile/font/normal_mobile_2015.css',
            },
            {
                type: 'module',
                src: 'Test/Level2',
                priority: 1,
            },
            {
                type: 'module',
                src: 'Gazzetta/Permutive',
                priority: 2,
            },
        ],
    },
};
